<template>
    <div class="content-inner">
        <el-container style="height: calc(100vh - 100px); border: 1px solid #eee">
            <el-aside width="280px" style="background-color: rgb(238, 241, 246)">
                <el-menu :default-openeds="['1']" default-active="1-1">
                    <el-submenu index="1">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <span class="text-uppercase font-weight-bold text-grey">Xero</span>
                        </template>
                        <el-menu-item
                            index="1-1"
                            @click="currentNav = 'invoices'"
                        >Invoices
                        </el-menu-item>
                        <el-menu-item
                            index="1-2"
                            @click="currentNav = 'reports'"
                        >Reports
                        </el-menu-item>
                        <el-menu-item
                            index="1-3"
                            @click="currentNav = 'mappings'"
                        >Mappings
                        </el-menu-item>
                        <el-menu-item
                            index="1-4"
                            @click="currentNav = 'settings'"
                        >Settings
                        </el-menu-item>
                        <!-- <el-menu-item
                            index="1-5"
                            @click="currentNav = 'exports'"
                        >Export</el-menu-item> -->
                    </el-submenu>
                </el-menu>
            </el-aside>

            <el-container>
                <el-header class="w-25" v-if="['settings', 'mappings'].includes(currentNav)">
                    <el-row>
                        <el-col :span="12">
                            <div class="tab-title text-uppercase font-weight-bold text-info px-1 w-50">
                                {{ currentNav }}
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="text-right font-weight-bold">
                                <template v-if="!connection">
                                    <a
                                        :href="Ambition.Globals.tenant.admin_url + '/admin/xero/auth/' + Ambition.Globals.tenant.tenantId"
                                    >Connect to Xero</a>
                                </template>
                                <template v-else>
                                    <a
                                        class="text-danger"
                                        href="#"
                                        @click.stop="disconnect"
                                    >DISCONNECT</a>
                                </template>
                            </div>
                        </el-col>
                    </el-row>
                </el-header>

                <el-main
                    class="p-0"
                    style="background-color: #ffffffc7"
                >
                    <template v-if="currentNav == 'invoices'">
                        <xero-invoices
                            :connection="connection">
                        </xero-invoices>
                    </template>

                    <template v-if="currentNav == 'reports' && connection">
                        <report-builder></report-builder>
                    </template>

                    <template v-if="currentNav == 'mappings' && connection">
                        <xero-mappings
                            :connection="connection">
                        </xero-mappings>
                    </template>

                    <template v-if="currentNav == 'settings' && connection">
                        <el-card class="box-card w-50" shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>Xero User Account</span>
                                <el-button
                                    type="text"
                                    class="text-red"
                                    style="float: right; padding: 3px 0"
                                    @click="disconnect"
                                >Disconnect
                                </el-button>
                            </div>
                            <div>
                                <el-form label-position="top">
                                    <el-form-item label="Xero User">
                                        <el-input
                                            :value="`${connection.identity.given_name} ${connection.identity.family_name} (${connection.identity.email})`"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Xero Account" required>
                                        <el-select v-model="connection.tenantId" class="w-100">
                                            <el-option
                                                v-for="org in connection.tenants"
                                                :key="org.tenantId"
                                                :value="org.tenantId"
                                                :label="org.tenantName"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="Default Invoice Status" required>
                                        <el-select v-model="accountSettings.default_invoice_status" class="w-100">
                                            <el-option value="DRAFT" label="Draft"></el-option>
                                            <el-option value="SUBMITTED" label="Awaiting Approval"></el-option>
                                            <el-option value="AUTHORISED" label="Awaiting Payment"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="Invoice Import Mode" required>
                                        <el-select v-model="accountSettings.invoice_upload_type" class="w-100">
                                            <el-option value="MANUAL" label="Manual"></el-option>
                                            <el-option value="AUTO" label="Automatic"></el-option>
                                            <!-- <el-option value="BATCHED" label="Batched Nightly" disabled></el-option> -->
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item v-if="accountSettings.invoice_upload_type != 'MANUAL'"
                                                  label="Import On Status" required>
                                        <el-select v-model="accountSettings.import_on_status" class="w-100">
                                            <el-option value="SETTLED" label="Settled"></el-option>
                                            <el-option value="COMPLETED" label="Completed"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="save">Save</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-card>
                    </template>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import XeroMappings from '@tenant/ambition/components/xero/xeroMappings';
import XeroInvoices from '@tenant/ambition/components/xero/xeroInvoices';
import ReportBuilder from '@tenant/ambition/components/reports/ReportBuilder';

export default {
    name: "XeroMain",
    components: {
        XeroMappings,
        XeroInvoices,
        ReportBuilder
    },
    props: {
        xero: {
            required: false,
        },
        settings: {
            required: false,
        },
    },
    data() {
        return {
            currentNav: 'invoices',
            connection: null,
            accountSettings: null,
            invoiceStatus: 'SUBMITTED',
            invoiceImportMode: 'AUTO',
            importOnStatus: 'COMPLETED'
        }
    },
    created() {
        this.connection = _.get(this.xero, 'source')
        this.accountSettings = Object.assign({
            default_invoice_status: 'SUBMITTED',
            invoice_upload_type: 'MANUAL',
            import_on_status: 'COMPLETED'
        }, this.settings)
    },
    methods: {
        disconnect() {
            this.$tenant.get("/admin/xero/disconnect")
                .finally(() => {
                    this.connection = null;

                    this.$notify({
                        type: 'success',
                        customClass: 'xero-notification',
                        title: 'Disconnect Xero',
                        message: 'Xero Disconnected Successfully',
                        position: 'bottom-right'
                    });
                })
        },
        save() {
            this.$tenant.post("/api/xero/settings/save", {
                params: {
                    tenantId: this.connection.tenantId,
                    invoiceStatus: this.accountSettings.default_invoice_status,
                    invoiceImportMode: this.accountSettings.invoice_upload_type,
                    importOnStatus: this.accountSettings.invoice_upload_type == 'AUTO' ? this.accountSettings.import_on_status : 'COMPLETED',
                }
            }).then(res => {
                this.$notify({
                    type: 'success',
                    customClass: 'xero-notification',
                    title: 'Saving Xero Settings',
                    message: 'Saving Xero Settings Successful',
                    position: 'bottom-right'
                });
            })
        }
    },
}
</script>

<style lang="scss">
.el-header {
    background-color: #eeeeee;
    color: #333;
    line-height: 60px;
}

.el-aside {
    color: #333;
}
</style>
